module.exports = __webpack_public_path__ + "img/amazon-bg.26c66b6b.svg";